const namespace = 'AUTH';
export const USER_LOGOUT = namespace + "@USER_LOGOUT";